
import LoadService from 'services/load-service';
var CourseSettingsService = require('services/course-settings-service');
var EnrollmentDataService = require('services/enrollment-data-service');
import { SessionStorageService } from 'services/web-storage-service';
var utils = require('lib/utils');
var DefaultContent = require('data/content');

var LocaleService = function() {
  if(LocaleService.prototype._singleton) {
    return LocaleService.prototype._singleton;
  }

  LocaleService.prototype._singleton = this;

  this.files = {
    _localeContent: './content/locales/{{locale}}.json',
    _langContent: './content/locales/{{lang}}.json',
  };

  this.fallbackNSes = ['course', 'sdk'];
  this.moduleNS = null;

  this.initialize = function(options) {
    return new Promise((resolve, reject) => {
      const split = CourseSettingsService.get('split_module');
      this.courseSupLanguages = CourseSettingsService.get('supported_languages');
      this.fallbackLng = 'en';
      this.filePaths = {
        _localeContent: split ? `./modules/${split}/locales/{{locale}}.json` : './content/locales/{{locale}}.json',
        _langContent: split ? `./modules/${split}/locales/{{lang}}.json` : './content/locales/{{lang}}.json',
      };

      // Check if the options language is setted up, format it if is declared with other nomenclature
      // otherwise will be undefined and used the fallback declared on the i18next object
      if(options.lng && !this.courseSupLanguages.includes(options.lng)) {
        if(options.lng.indexOf('-') === 2) {
          options.lng = this.courseSupLanguages.includes(options.lng.substring(0, 2)) ? options.lng.substring(0, 2) : undefined;
        } else {
          options.lng = undefined;
        }
      }

      var i18nextOptions = _.defaults(
        {
          fallbackLng: this.fallbackLng,
          fallbackNS: this.fallbackNSes,
          keySeparator: '.',
          nsSeparator: '<|>',
          detection: {
            order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
            lookupQuerystring: 'setLng',
            lookupCookie: 'i18next',
            lookupLocalStorage: 'i18nextLng',
          },
          whitelist: this.courseSupLanguages,
          interpolationPrefix: '{{',
          interpolationSuffix: '}}',
          customLoad: function(lng, ns, options, loadComplete) {
            //we're loading the files ourselves, don't need i18next to do it;
            // can't find another way of turning this off...
            loadComplete(null, null);
          },
        },
        options
      );
      i18next.use(window.i18nextBrowserLanguageDetector).init(i18nextOptions, () => {
        const i18nextLang = i18next.language;
        this.setFileConfigData(i18nextLang);

        this.loadLanguageFileData(this.files)
          .then(resolve)
          .catch(() => {
            this.setFileConfigData(this.fallbackLng);
            return this.loadLanguageFileData(this.files).then(() => {
              // eslint-disable-next-line no-console
              console.info('Fallback language loaded successfully');
              resolve();
            }).catch(() => {
              const errMessage = 'Couldn\'t load the fallback language'
              // eslint-disable-next-line no-console
              console.info(errMessage);
              reject(errMessage);
            });
          })
          .catch(() => {
            // eslint-disable-next-line no-console
            console.info("Couldn't load the desired language");
          });
        if(DefaultContent[this.lang]) {
          i18next.addResourceBundle(this.lang, 'sdk', DefaultContent[this.lang]);
        }
        if(DefaultContent[this.locale]) {
          i18next.addResourceBundle(this.locale, 'sdk', DefaultContent[this.locale]);
        }
        i18next.addResourceBundle('en', 'sdk', DefaultContent.en);
      });
    });
  };

  this.setFileConfigData = function(i18nextLang) {
    if(i18nextLang.indexOf('-') === 2) {
      this.lang = i18nextLang.substring(0, 2);
      this.locale = i18nextLang;
      this.files._localeContent = this.filePaths._localeContent.replace('{{locale}}', this.locale);
    } else {
      this.lang = i18nextLang;
      this.locale = undefined;
      delete this.files._localeContent;
    }
    this.files._langContent = this.filePaths._langContent.replace('{{lang}}', this.lang);

    if(i18nextLang != 'en') {
      this.files._enContent = './content/locales/en.json';
    }
  };

  this.loadLanguageFileData = function(filesConfig) {
    return LoadService.load(filesConfig).then((data) => {
      Object.defineProperty(this, 'localeContent', {
        get: function() {
          return data._localeContent;
        },
      });
      Object.defineProperty(this, 'langContent', {
        get: function() {
          return data._langContent;
        },
      });
      Object.defineProperty(this, 'enContent', {
        get: function() {
          return data._enContent;
        },
      });
      _.each(this.fallbackNSes, (ns) => {
        this.addResources(ns);
      });
    });
  };

  this.addDefaultResources = function(namespace) {
    var prefix = EnrollmentDataService.getData('locale:namespace:prefix');
    var prefixedNameSpace = prefix ? `${prefix}|${namespace}` : namespace;
    this.addResources(namespace);
    this.addResources(prefixedNameSpace);
    if(this.moduleNS) {
      i18next.options.fallbackNS = [namespace].concat(this.fallbackNSes).concat(this.moduleNS);
    }
    i18next.setDefaultNamespace(prefixedNameSpace);
  };

  this.setLocaleNamespacePrefix = function(prefix) {
    EnrollmentDataService.saveData('locale:namespace:prefix', prefix);
  };

  this.setModuleResources = function(moduleKey) {
    var ns = moduleKey + '.defaults';
    this.addResources(ns);
    this.moduleNS = ns;
    //overwrite other fallbacks when starting a new module
    i18next.options.fallbackNS = [ns].concat(this.fallbackNSes);
  };

  this.addResources = function(namespace) {
    //en should always be present
    if(!i18next.hasResourceBundle('en', namespace)) {
      this.addResource(this.lang, namespace, this.langContent);

      if(this.locale) {
        this.addResource(this.locale, namespace, this.localeContent);
      }

      if(i18next.language != 'en') {
        this.addResource('en', namespace, this.enContent);
      }
    }
  };

  this.currentNamespace = function() {
    return i18next.options.defaultNS;
  };

  this.addResource = function(lang, namespace, content) {
    var resource = utils.dotStringToObject(namespace, content);
    i18next.addResourceBundle(lang, namespace, resource);
  };

  this.t = function(key, options) {
    var sessionData = SessionStorageService.getAll();
    var model = CourseSettingsService.getModel();
    var courseData = model ? model.toJSON() : {};
    var data = _.extend(sessionData, courseData, options);
    return i18next.t(key, data);
  };

  this.getLanguage = function() {
    return i18next.language;
  };

  this.isRTL = function() {
    switch(i18next.language) {
      case 'ar':
      // Arabic
      case 'he':
      // Hebrew
      case 'ur':
        // Urdu
        return true;
      default:
        return false;
    }
  };
};

module.exports = new LocaleService();
